import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import SenderArea from "./area/sender";
import SmsListArea from "./area/list";

function SendSmsEachPopup(props: any) {
  let myProps = {
    callback_refresh: () => { },
    closePopup: () => { },
    sms_data_arr: [],//[{phone_num:"",user_name:"",user_seq:"",content:""}]
    sms_title:"알림",
    ...props
  };
  let user = useSelector((state: any) => state.user);

  const [msg_row, set_msg_row] = useState({
    "a_owner_mcomp_seq":user.comp_seq,
    "a_sender_mcomp_seq":user.comp_seq,
    "a_sender":user.user_name,
    "a_sender_user_seq":user.user_seq,
    "a_sender_phone_num":"16888764",
    "a_receiver_mcomp_seq":user.comp_seq,
    "a_title":myProps.sms_title,
    "a_content":"",
    "a_is_mms":"",
  });
  const [mcomp_point, set_mcomp_point] = useState<any>(0);
  const [sender_tel_arr,set_sender_tel_arr]=useState([]);
  const [sms_data_arr, set_sms_data_arr] = useState(myProps.sms_data_arr);
  const [check_row_num_arr, set_check_row_num_arr] = useState([]);

  useEffect(() => {
    getSenderPhoneNumberByAjax();
    getPointNumByAjax();
  }, [user]);

  const getPointNumByAjax = () => {
    if (user.comp_seq) {

    } else {
      return false;
    }
    let point_form_json = {
      "s_seq": [user.comp_seq],
      "is_addon_point_tot": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', point_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_info = response.data["data"]["info_arr"][0];
            if (corp_info.point_tot_info) {
              set_mcomp_point(corp_info.point_tot_info.tot);
            }
          }
        } else {

        }
      });
  };

  const getSenderPhoneNumberByAjax=()=>{
    let from_json_data={};
    my_axios.post( process.env.REACT_APP_API_URL+'/api/main/basic/sms_sender/get_front_list',from_json_data,get_axios_data())
    .then((response) => {
      if(response.data["result"]==="true"){
        set_sender_tel_arr(response.data["data"]["select_row_arr"]);
        if(response.data["data"]["select_row_arr"].length>0){
          set_msg_row({
            ...msg_row,
            "a_sender_phone_num":response.data["data"]["select_row_arr"][0].value
          });
        }
      }
    });
  };

  const sendSmsMessage = () => {
    if (sms_data_arr.length == 0) {
      alert("전송할 메세지가 없습니다.");
      return false;
    }
    for(let i=0;i<sms_data_arr.length;i++){
      let row_sms_data=sms_data_arr[i];
      if(strFunc.is_empty(row_sms_data.phone_num)){
        alert("전화번호가 없습니다.");
        return false;
      }
      if(strFunc.is_empty(row_sms_data.user_name)){
        alert("유저명이 없습니다.");
        return false;
      }
    }
    if(!confirm("메세지를 보내시겠습니까?")){
      return false;
    }
    
    let send_sms_form_json={
      msg_row:msg_row,
      sms_data_arr:sms_data_arr,
    };
    my_axios.post( process.env.REACT_APP_API_URL+'/api/main/basic/sms/send_sms_multy',send_sms_form_json,get_axios_data())
    .then((response) => {
      if(response.data["result"]==="true"){
        myProps.callback_refresh();
        alert(response.data["msg"]);
        myProps.closePopup();
      }else{
        alert(response.data["msg"]);
      }
    });
  };

  return (
    <div>
      <div className="text-right">
        남은 포인트:<span className="ml-2" style={{ color: "red" }}>{strFunc.comma(mcomp_point)}</span>
      </div>
      <div className="mt-1">
        <SenderArea
          msg_row={msg_row}
          set_msg_row={set_msg_row}
          sender_tel_arr={sender_tel_arr}
        ></SenderArea>
      </div>
      <div className="mt-1">
        <SmsListArea
          sms_data_arr={sms_data_arr}
          set_sms_data_arr={set_sms_data_arr}
          check_row_num_arr={check_row_num_arr}
          set_check_row_num_arr={set_check_row_num_arr}
        ></SmsListArea>
      </div>
      <div className="btn-box-center mt-2">
        <button className="btn btn-line-gray" onClick={() => { sendSmsMessage(); }}>전송</button>
        <button className="btn btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
    </div>
  );
};
export default SendSmsEachPopup;